<template>
    <div v-if="status===0" style="text-align: center;color: #ee0a24;font-size: 18px;margin-top: 20%"></div>
    <div v-else-if="status===1"style="text-align: center;color: #ee0a24;font-size: 18px;margin-top: 20%">正在跳转微信支付...</div>
    <div v-else style="text-align: center;color: #ee0a24;font-size: 18px;margin-top: 20%">
        <div>出错了！</div>
    </div>
</template>

<script>
    export default {
        name: "SkipPageGreen",
        data() {
            return {
                status:0
            }
        },
        created:function () {
            this.params = this.weutil.getParams(window.location.href);

            if(this.params.uid && this.params.app_id && this.params.project_id){
                this.status = 1
                this.wepay()
            }
            else{
                this.status = -1
            }
        },
        methods:{
            payOk:function(){
                this.$router.go(-1);
            },
            wepay:function () {
            }
        }
    }
</script>

<style scoped>

</style>
